module.exports = __webpack_public_path__ + "img/portraits_14_V.e67985a1.webp";